import { render, staticRenderFns } from "./branch-company-form.vue?vue&type=template&id=4d768852&"
import script from "./branch-company-form.vue?vue&type=script&lang=js&"
export * from "./branch-company-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports